import { ReactElement } from 'react';
import { Container, Headline, Note } from './Header.styles';

export type HeaderProps = {
  headline: string,
  mobileOnlyHeadline?: boolean,
  note?: string,
};

const Header = ({ headline, mobileOnlyHeadline, note }: HeaderProps): ReactElement => (
  <Container>
    <Headline className={mobileOnlyHeadline ? '--no-desktop' : undefined}>{headline}</Headline>
    {note && (
      <Note>{note}</Note>
    )}
  </Container>
);

export default Header;
